import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NewLanguageSwitcherLanding } from "./LanguageSwitcher";
import landing from "../styles/components/landing.module.scss";
import styles from "../styles/components/langButtons.module.scss";
import en from "../assets/images/en.webp";
import ar from "../assets/images/ar.webp";
import fr from "../assets/images/fr.webp";

const LANGUAGES = { en: { code: "En", flag: en }, fr: { code: "Fr", flag: fr }, ar: { code: "Ar", flag: ar } };

// Language choice of the new design: the flag switcher already used in production.
// With two languages a tap switches to the other one directly (same button, no menu);
// with more, the production menu opens.
// `align="end"` opens the menu from the end edge, for a switcher placed at the end of a bar.
export default function LangButtons({ currentLang, setCurrentLang, align }) {
  const { t, i18n } = useTranslation();
  const availableLanguages = useSelector((state) => state.tenant?.tenant.languages) || [];
  const other = availableLanguages.length === 2 ? availableLanguages.find((lang) => lang !== currentLang) : null;
  const current = LANGUAGES[currentLang];

  if (other && current && LANGUAGES[other]) {
    return (
      <div className={styles.wrap}>
        <div className={landing.lang_selector}>
          <button
            type="button"
            className={landing.lang_button}
            onClick={() => {
              i18n.changeLanguage(other); // use i18n method so language is switched in all the app
              setCurrentLang(other);
            }}
          >
            <img className={landing.lang_flag} src={current.flag} alt={t(currentLang)} loading="lazy" />
            <span>{current.code}</span>
            <svg className={landing.arrow} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.wrap, { [styles.end]: align === "end" })}>
      <NewLanguageSwitcherLanding currentLang={currentLang} setCurrentLang={setCurrentLang} />
    </div>
  );
}
